import React, { useEffect, useState } from "react";
import Heading from "../../components/Heading";
import CommonGrid from "../../components/CommonGrid";
import DynamicComponentRenderer from "../../components/DynamicComponentRenderer";
import {
  gridColumns_demandPayoff,
  gridColumns_payoff_authorization,
} from "../../Utils/TableColumnDefs";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPayoffDemands,
  fetchPayoffDemandsThirdParty,
} from "../../store/reducers/dashboardSlice/api";
import { useAbortController } from "../../hooks/useAbortController";
import classes from "../../pages/ReportsNDocuments/reports.module.css";
import { LiHandleButton } from "../../Utils/CustomComponent";
import { FaHandshake } from "react-icons/fa";
import { Button } from "react-bootstrap";
import { VOMNavbar } from "../VerificationForm";
import { useLocation, useNavigate } from "react-router-dom";

const ThirdPartyPayoffs = () => {
  const [activeTab, setActiveTab] = useState(0);
  const thirdPartyRequests = useSelector(
    (state) => state.dashboard.thirdPartyPayoffRequests.data,
  );
  const thirdPartyStatus = useSelector(
    (state) => state.dashboard.thirdPartyPayoffRequests.status,
  );
  const navigate = useNavigate();
  const location = useLocation();

  const isExternalBorrower =
    location.pathname === "/authorize-requests" &&
    location.state.authorizedBorrower === true;
  const email = localStorage.getItem("email_for_payoff");

  const PendingRequests =
    thirdPartyRequests?.filter((el) => el.status === "PENDING") || [];
  const RejectedRequests =
    thirdPartyRequests?.filter((el) => el.status === "EXPIRED") || [];
  const SubmittedRequests =
    thirdPartyRequests?.filter((el) => el.status === "SUBMITTED") || [];

  const dispatch = useDispatch();
  const { signal } = useAbortController();

  useEffect(() => {
    dispatch(
      fetchPayoffDemandsThirdParty({
        email: email,
        signal,
      }),
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const componentConfig = [
    {
      component: <Heading className="col-sm-12" text="Demand Payoff Loans" />,
      role: ["Both"],
      className: "col-sm-6 px-5",
    },
    {
      component: (
        <Button
          className="text-white create-ticket"
          onClick={() => navigate("/payoff-request-form")}
        >
          <FaHandshake className="me-3" /> Request Payoff
        </Button>
      ),
      // role: ["Both"],
      className: `col-sm-6 px-5 text-end ${isExternalBorrower ? "d-none" : ""}`,
    },

    {
      component: (
        <div>
          <ul className="nav nav-tabs my-5">
            {tabButtons.map((data, index) => (
              <LiHandleButton
                key={index}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                label={data.label}
                value={index}
                handleBtnClick={setActiveTab}
              />
            ))}
          </ul>

          <section className="row d-flex flex-row align-items-stretch justify-content-stretch">
            {activeTab === 0 && (
              <CommonGrid
                className={classes.pastDue25}
                title={"Pending Borrower Authorization"}
                gridColumns={gridColumns_payoff_authorization(
                  isExternalBorrower ? true : false,
                )}
                columnData={PendingRequests}
                status={thirdPartyStatus}
              />
            )}
            {activeTab === 1 && (
              <CommonGrid
                className={classes.pastDue25}
                title={"Submitted Payoff Request(s)"}
                gridColumns={gridColumns_payoff_authorization(
                  isExternalBorrower ? true : false,
                )}
                columnData={SubmittedRequests}
                status={thirdPartyStatus}
              />
            )}
            {activeTab === 2 && (
              <CommonGrid
                className={classes.pastDue25}
                title={"Rejected Payoff Request(s)"}
                gridColumns={gridColumns_payoff_authorization(
                  isExternalBorrower ? true : false,
                )}
                columnData={RejectedRequests}
                status={thirdPartyStatus}
              />
            )}
          </section>
        </div>
      ),
      role: ["Both"],
      className: "col-sm-12 px-4",
    },
  ];
  return (
    <div
      className="text-start container-fluid my-0 px-0"
      style={{ overflowY: "scroll" }}
    >
      <VOMNavbar title={isExternalBorrower ? "Payoff Authorization" : "Request Payoff"} />
      <section
        className=" rounded pb-5"
        style={{
          background: "#eeeeee",
          minHeight: "100vh",
          paddingTop: "80px",
        }}
      >
        <article className="container-fluid row mt-5">
          <DynamicComponentRenderer componentConfig={componentConfig} />
        </article>
      </section>
    </div>
  );
};

export default ThirdPartyPayoffs;

const tabButtons = [
  {
    label: "Pending Borrower Authorization",
    title: "Pending Borrower Authorization",
  },
  {
    label: "Submitted Payoff Request(s)",
    title: "Submitted Payoff Request(s)",
  },
  { label: "Rejected Payoff Request(s)", title: "Rejected Payoff Request(s)" },
];
